import axios from "axios";
import { SERVER_URL } from "Constants";

export type OrderItem = {
	name: string;
	description: string;
	price: number;
	priceIncGst: number;
}

export type PaymentSummary = {
	items: OrderItem[];
	totalAmountIncGst: number;
	totalAmountExcGst: number;
	gstRate: number;  // 0.1 for 10%
	gstAmount: number;
}

export type ServicePrice = {
	id: string;
	serviceType: "MotorVehicleSearch" | "CreditReport"; // Future Note:- Extend this to other types of service such as "PropertySearch", "PPSRRegistration", etc.
}

export type PaymentSummaryRequest = {
	organisationId?: string;
	services: ServicePrice[];
}

export async function getPaymentSummary(request: PaymentSummaryRequest) {
	const response = await axios.post<PaymentSummary>(`${SERVER_URL}/api/payment/summary`, request);
	return response;
}